var _defs, _g, _path, _path2, _ellipse, _polygon, _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconConfirmacaoSeguranca(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FED82BF2-17A3-423C-A743-598E5A6FF0FD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 41,
    cy: 41,
    r: 41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.0829974%",
    x2: "100%",
    y2: "50.0829974%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EBD0",
    stopOpacity: 0,
    offset: "65%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.15,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EBD0",
    stopOpacity: 0,
    offset: "65%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.15,
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "5.0---Login-/-Cadastro",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.3-Valida\\xE7\\xE3o-cadastro",
    transform: "translate(-561.000000, -167.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(561.000000, 167.000000)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("circle", {
    stroke: "#E4E9FF",
    cx: 41,
    cy: 41,
    r: 40.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vetor_Sombra",
    transform: "translate(15.000000, 17.000000)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.806875,26.8907563 L38.193125,26.8907563 L35.1207813,10.2058824 C35.0594445,9.61894663 34.5720397,9.17327052 33.9903906,9.17226891 L19.0096094,9.17226891 C18.4279603,9.17327052 17.9405555,9.61894663 17.8792187,10.2058824 L14.806875,26.8907563 Z",
    id: "Path",
    fill: "#F97A70",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.806875,26.8907563 L38.193125,26.8907563 L35.1207813,10.2058824 C35.0594445,9.61894663 34.5720397,9.17327052 33.9903906,9.17226891 L19.0096094,9.17226891 C18.4279603,9.17327052 17.9405555,9.61894663 17.8792187,10.2058824 L14.806875,26.8907563 Z",
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9449539,9.18907563 L31.9449539,4.37394958 C31.9493289,3.21472571 31.4983221,2.10150771 30.6916988,1.28062458 C29.8850754,0.459741448 28.78934,-0.00112649728 27.6469531,-2.06026829e-06 L25.3530469,-2.06026829e-06 C24.2135356,-0.00111505737 23.1203196,0.457447446 22.3141748,1.27469113 C21.5080301,2.09193481 21.0550781,3.20082837 21.0550781,4.35714286 L21.0550781,9.17226891",
    id: "Path",
    stroke: "#020202",
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFEC8D",
    fillRule: "nonzero",
    cx: 26.5,
    cy: 15.9411765,
    rx: 2.19453125,
    ry: 2.22689076
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFEC8D",
    fillRule: "nonzero",
    points: "23.7009375 23.1218487 29.2990625 23.1218487 27.4192188 17.2815126 25.5807812 17.2815126"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#465EFF",
    fillRule: "nonzero",
    x: 0.099375,
    y: 30.210084,
    width: 52.80125,
    height: 13.487395,
    rx: 4.48
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    x: 0.099375,
    y: 30.210084,
    width: 52.80125,
    height: 13.487395,
    rx: 4.48
  }), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.71609375,
    y1: 32.7268908,
    x2: 6.71609375,
    y2: 40.5378151,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.0782812,
    y1: 36.6302521,
    x2: 3.35390625,
    y2: 36.6302521,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.339375,
    y1: 33.8697479,
    x2: 9.0928125,
    y2: 39.394958,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 4.339375,
    y1: 39.394958,
    x2: 9.0928125,
    y2: 33.8697479,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 14.5460156,
    y1: 32.7268908,
    x2: 14.5460156,
    y2: 40.5378151,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 17.9082031,
    y1: 36.6302521,
    x2: 11.1838281,
    y2: 36.6302521,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 12.1692969,
    y1: 33.8697479,
    x2: 16.9227344,
    y2: 39.394958,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 12.1692969,
    y1: 39.394958,
    x2: 16.9227344,
    y2: 33.8697479,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 22.5498437,
    y1: 32.7268908,
    x2: 22.5498437,
    y2: 40.5378151,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 25.9120312,
    y1: 36.6302521,
    x2: 19.1876562,
    y2: 36.6302521,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 20.173125,
    y1: 33.8697479,
    x2: 24.9265625,
    y2: 39.394958,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 20.173125,
    y1: 39.394958,
    x2: 24.9265625,
    y2: 33.8697479,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 30.4501563,
    y1: 32.7268908,
    x2: 30.4501563,
    y2: 40.5378151,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 33.8123438,
    y1: 36.6302521,
    x2: 27.0879688,
    y2: 36.6302521,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 28.0734375,
    y1: 33.8697479,
    x2: 32.826875,
    y2: 39.394958,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 28.0734375,
    y1: 39.394958,
    x2: 32.826875,
    y2: 33.8697479,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 38.2800781,
    y1: 32.7268908,
    x2: 38.2800781,
    y2: 40.5378151,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 41.6422656,
    y1: 36.6302521,
    x2: 34.9178906,
    y2: 36.6302521,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 35.9033594,
    y1: 33.8697479,
    x2: 40.6567969,
    y2: 39.394958,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 35.9033594,
    y1: 39.394958,
    x2: 40.6567969,
    y2: 33.8697479,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 46.2839063,
    y1: 32.7268908,
    x2: 46.2839063,
    y2: 40.5378151,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 49.6460937,
    y1: 36.6302521,
    x2: 42.9217187,
    y2: 36.6302521,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 43.9071875,
    y1: 33.8697479,
    x2: 48.660625,
    y2: 39.394958,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 43.9071875,
    y1: 39.394958,
    x2: 48.660625,
    y2: 33.8697479,
    id: "Path",
    stroke: "#83FFEA",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#465EFF",
    fillRule: "nonzero",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply"
    },
    cx: 26.5,
    cy: 48.7394958,
    rx: 26.400625,
    ry: 1.02941176
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConfirmacaoSeguranca);
export default __webpack_public_path__ + "static/media/iconConfirmacaoSeguranca.fd89fbfa26ecb3367ddce50877f47e95.svg";
export { ForwardRef as ReactComponent };